<template>
    <div class="wrap">
        <!-- 顶部导航栏-->
        <my-header title="组织关系转接办理"></my-header>
        <!--头部-->
        <div class="hd"></div>
        <!-- 步骤条盒子 -->
        <van-steps :active="active" active-icon="success"  active-color="#e32322">
            <van-step>提交申请</van-step>
            <van-step>转出审批</van-step>
            <van-step>转入审批</van-step>
            <van-step>分配组织</van-step>
            <van-step>完成</van-step>
        </van-steps>
        <div class="zhuanchu">
            <span class="tag">转出</span>
            <div class="cell_wrap">

                <van-cell title="团支部" is-link @click="clickOut" required>
                    <template>
                        {{ruleForm.outLeagueName == '' ? '请选择' : ruleForm.outLeagueName}}
                    </template>
                </van-cell>


                <van-cell title="团支部管理员" :value="adminName" />
                <van-cell title="团支部联系方式" :value="adminMobile" />
                <van-cell title="转出团支部的直属上级联系方式" :value="DSuperiorPhone"></van-cell>


                <van-cell title="转出人姓名" is-link @click="clickOutUser" required>
                    <template>
                        {{ruleForm.selectUserName == '' ? '请选择' : ruleForm.selectUserName}}
                    </template>

                </van-cell>
                <van-cell title="转出人身份证号" :value="userCard" />
                <van-cell title="转出人手机号码" :value="userMobile" />
                <van-cell title="常用人联系方式"  required>
                    <template #right-icon>
                        <input type="text" placeholder="请输入" class="telInput" v-model="ruleForm.commonlyUsePhone">
                    </template>
                </van-cell>

            </div>

        </div>
        <div class="zhuanru">
            <span class="tag">转入</span>
            <div class="cell_wrap">
                <van-cell title="组织是否属于北京/广东/福建" is-link @click="showPickerIsThree = true" required>
                    <template>
                        {{ruleForm.isForeign == 0 ? "否" : "是"}}
                    </template>
                </van-cell>

                <van-cell v-if="ruleForm.isForeign == 1" title="转入组织属于哪个省" is-link @click="showPickerThree = true">
                    <template>
                        {{otherOrgName == '' ? "请选择" : otherOrgName}}
                    </template>
                </van-cell>

                <van-cell title="转出原因" is-link @click="showPickerOutReason = true" required>
                    <template >
                        {{outReason == '' ? "请选择" : outReason}}
                    </template>
                </van-cell>

                <div v-if="showWhereToGraduate">
                    <van-cell title="毕业去向" is-link @click="showPickerGraWhere = true" required  >
                        <template>
                            {{graduateName == '' ? "请选择" : graduateName}}
                        </template>
                    </van-cell>
                </div>

                <div v-if="twoUnit">
                    <van-cell :title="unitNameTitle" required >
                        <template #right-icon>
                            <input type="text" placeholder="请输入" class="telInput" v-model="ruleForm.unitName">
                        </template>
                    </van-cell>

                    <van-cell :title="unitAddressTitle" is-link :required="MustAddress"
                              @click="onClickAddress" v-model="ruleForm.unitAddress">

                    </van-cell>

                </div>
                <div v-else-if="oneUnit">
                    <van-cell :title="unitAddressTitle" required >
                        <template #right-icon>
                            <input type="text" placeholder="请输入" class="telInput" v-model="ruleForm.unitAddress">
                        </template>
                    </van-cell>
                </div>


                <div v-if="ruleForm.outReson!=6">
                    <van-cell  center required title="转入组织" is-link @click="showOrgPick = true" v-model="ruleForm.selectedOrg" />
                    <van-cell title="转入组织管理员" :value="inAdminName" />
                    <van-cell title="转入组织联系方式" :value="inAdminMobile" />

                </div>

            </div>

        </div>

        <van-field
            v-model="ruleForm.remark"
            :required="mustRemark"
            autosize
            type="textarea"
            maxlength="100"
            :placeholder="mustRemark?'请说明选择转出原因为“未就业”的原因，最多100个字':'请输入备注，最多100个字……'"
            show-word-limit
        />

        <div class="btn_wrap">
            <van-button color="#e32322" @click="onSubmit">提交</van-button>

        </div>

        <van-popup v-model="showPickerIsThree" round position="bottom">
            <van-picker
                show-toolbar

                value-key="name"
                :columns="isThreeList"
                @cancel="showPickerIsThree = false"
                @confirm="onConfirmIsThree"
            />
        </van-popup>
        <van-popup v-model="showPickerThree" round position="bottom">
            <van-picker
                show-toolbar

                value-key="name"
                :columns="outProvince"
                @cancel="showPickerThree = false"
                @confirm="onConfirmThree"
            />
        </van-popup>
        <van-popup v-model="showPickerOutReason" round position="bottom">
            <van-picker
                show-toolbar
                title="选择转出原因"
                value-key="name"
                :columns="currentTransferReason"
                @cancel="showPickerOutReason = false"
                @confirm="onConfirmOutReason"
            />
        </van-popup>
        <van-popup v-model="showPickerGraWhere" round position="bottom">
            <van-picker
                show-toolbar
                title="选择毕业去向"
                value-key="name"
                :columns="whereToGraduates"
                @cancel="showPickerGraWhere = false"
                @confirm="onConfirmGraWhere"
            />
        </van-popup>

        <van-popup v-model="showPickerSelectOutUser" round position="bottom">
            <van-picker
                show-toolbar
                title="选择转出团员"
                value-key="name"
                :columns="userList"

                @cancel="showPickerSelectOutUser = false"
                @confirm="onConfirmOutUser"
            />
        </van-popup>


        <van-popup v-model="showOrgPick" title="标题" show-cancel-button

                   position="bottom" round :style="{ height: '90%' }">
            <orgPick
                :is-tzb="1"
                leagueTypeId="01TZB,03TW,02TZZ,04TGW"
                v-on:orgSelected="onOrgSelected"> </orgPick>
        </van-popup>

        <van-popup v-model="showFormAddress"
                   round :style="{ height: '150px', width: '100%'}"
                    @close="updateAddress"
        >
            <van-cell style="margin-top: 30px" title="所在地区" is-link @click="showPickerAddress = true">
                <template>
                    {{tempAddress == '' ? "省/市/县" : tempAddress}}
                </template>
            </van-cell>

            <van-cell title="详细地址">
                <template>
                    <input type="text" placeholder="乡镇街道、门牌号" class="telInput" v-model="tempAddressDetail">
                </template>
            </van-cell>

        </van-popup>

        <van-popup v-model="showPickerAddress" title="选择地区" show-cancel-button
            position="bottom" round :style="{ height: '40%'}">
            <cityAddressPicker
                v-on:addressCanceled="onAddressCanceled"
                v-on:addressSelected="onAddressSelected"
            >

            </cityAddressPicker>
        </van-popup>


        <select-org-one class="telInput" leagueTypeId="01TZB,00DJZTZB,06BYBTZB" :show="showSelectedOutLeague"
                        @close="outLeagueClose($event)"
                        @chooseOrg="chooseOutOrg($event)"></select-org-one>
    </div>

</template>

<script>
import MyHeader from '../../../components/MyHeader'
import cons from '../../../cons.vue'
import {mapState} from "vuex";
import {Dialog} from "vant";
import orgPick from "@/views/orgPick";
import selectOrgOne from '../../../components/selectOrgOne'
import Toast from "vant/es/toast";
import cityAddressPicker from "@/components/cityAddressPicker";

export default {

    name: "transferPersonal",
    components: {
        MyHeader,
        orgPick,
        selectOrgOne,
        cityAddressPicker,
    },
    computed: {
        ...mapState({
            userId: state => state.user.userId,
            leagueId: state => state.league.leagueId,
            memberInfo: state => state.commonparams,
            curLeagueTypeId: state => state.league.leagueTypeId,
            curUser: state => state.user,
            curLeague: state => state.league,
            commonparams: state => state.commonparams,
            loginedInfo: state => state.loginedInfo,
        }),
        MustAddress() {
            if (this.ruleForm.outReson == 5)
                return true
            return false
        },
        unitNameTitle() {
            let type = parseInt(this.ruleForm.outReson)
            switch (type) {
                case 11:
                    return '新学校名称'
                case 4:
                case 5:
                case 7:
                    return '工作单位名称'
                default:
                    return ''
            }

        },
        unitAddressTitle() {
            let type = parseInt(this.ruleForm.outReson)
            switch (type) {
                case 11:
                    return '新学校所在地详细地址'
                case 4:
                case 5:
                case 7:
                    return '工作单位所在地详细地址'
                case 9:
                case 10:
                    return '户籍地或居住地详细地址'
                default:
                    return ''
            }
        },
        twoUnit() {
            switch (this.ruleForm.outReson) {
                case 11:
                case 4:
                case 5:
                case 7:
                    return true
                default:
                    return false
            }
        },
        oneUnit() {
            switch (this.ruleForm.outReson) {
                case 9:
                case 10:
                    return true
                default:
                    return false
            }
        },
    },

    data(){
        return{
            showPickerAddress: false,
            showFormAddress: false,

            active:0,
            loading: false,
            //
            showOrgPick: false,
            showPickerIsThree: false,
            showPickerThree: false,
            showPickerOutReason: false,
            showPickerGraWhere: false,

            showSelectedOutLeague: false,
            showPickerSelectOutUser: false,

            isThreeList: [
                {
                    name: '否',
                    value: 0,
                },
                {
                    name: '是',
                    value: 1,
                }
            ],

            transferReason: [
                {
                    name: '升学',
                    value: 2,
                },
                {
                    name: '工作',
                    value: 3,
                },
                {
                    name: '搬迁',
                    value: 1,
                },
                {
                    name: '转往特殊单位团组织',
                    value: 6,
                },
                {
                    name: '其它',
                    value: 0,
                },
                {
                    name: '升学',
                    value: 11,
                },
                {
                    name: '已落实工作单位（工作单位有团组织）',
                    value: 4,
                },
                {
                    name: '已落实工作单位（工作单位无团组织）',
                    value: 5,
                },
                {
                    name: '出国（因公出国／境）',
                    value: 7,
                },
                {
                    name: '出国（境）学习研究',
                    value: 8,
                },
                {
                    name: '出国（因私出国／境）',
                    value: 9,
                },
                {
                    name: '未就业',
                    value: 10,
                },
                {
                    name: '转往特殊单位团组织',
                    value: 6,
                },
            ],
            outProvince: [
                {
                    name: '请选择',
                    value: '',
                },
                {
                    name: '北京市（转往中央单位团组织的，请勿选择转往北京市）',
                    value: 'BJNG',
                },
                {
                    name: '广东省',
                    value: 'GDNG',
                },
                {
                    name: '福建省',
                    value: 'FJAN',
                },
            ],
            currentTransferReason:[],
            mustRemark: false,
            isSanSheng: '',
            showWhereToGraduate:false,
            whereToGraduates: [],
            graduateName: '',
            otherOrgName: '',
            outReason: '',
            ruleForm: {
                outLeagueId: '',
                outLeagueName: '',
                outLeagueFullName: '',
                selectUserId: '',
                selectUserName: '',
                outReson: '',
                remark: '',

                selectedOrg: '',
                selectedOrgId: '',
                selectedOrgFullName: '',
                selectedLeagueTypeId: '',

                unitName: '',
                unitAddress: '',
                isForeign: 0,
                commonlyUsePhone: '',
                whereToGraduate: -1,
                provinceId: '',

                otherOrgCode: '',
            },
            userCard: '',
            userMobile: '',
            userList:[],
            conflictUsers: {},

            DSuperiorPhone:'',
            adminName: '',
            adminMobile: '',

            inAdminName: '',
            inAdminMobile:'',
            curPage_: 1,

            tempAddress: '',
            tempAddressDetail:'',


        }
    },
    methods : {
        onClickAddress() {
            this.tempAddress = ''
            this.tempAddressDetail = ''
            this.ruleForm.unitAddress = ''
            this.showFormAddress = true
        },
        onAddressSelected(value) {
            this.tempAddress = value.join("")
            this.showPickerAddress = false
            console.log(this.tempAddress)
        },
        onAddressCanceled() {
            this.showPickerAddress = false
        },
        updateAddress() {
            this.ruleForm.unitAddress = this.tempAddress+this.tempAddressDetail
        },
        onLoad() {

        },
        clickOutUser() {
            console.log(this.userList)
            if(this.userList == null) {
                this.userList = []
            }
            this.showPickerSelectOutUser = true

        },

        clickOut() {
            this.showSelectedOutLeague = true
            console.log( this.showSelectedOutLeague)
        },
        outLeagueClose() {
            this.showSelectedOutLeague = false
        },
        chooseOutOrg(outLeagueInfo) {

            this.ruleForm.selectUserId = ''
            this.ruleForm.outLeagueName = outLeagueInfo.leagueName
            this.ruleForm.outLeagueFullName = outLeagueInfo.leagueFullName
            this.ruleForm.outLeagueId = outLeagueInfo.leagueId
            this.showSelectedOutLeague = false
            this.selectIndustryTypeId = outLeagueInfo.industryTypeId
            this.ruleForm.whereToGraduate = ''
            this.currentTransferReason = []
            this.whereToGraduates = []
            this.ruleForm.outReson = ''

            this.onOutLeagueChange(this.ruleForm.outLeagueId)

        },

        onOutLeagueChange(v) {
            let paramDate = new FormData()
            paramDate.append('currLeagueId', this.leagueId)
            paramDate.append('currUserId', this.userId)
            paramDate.append('statisticalLeagueId', v)
            let self = this
            this.$root.PF('/tuanyuan/leagueMemberStatistic', paramDate, {baseURL: cons.u}).then((response) => {
                self.loading = false
                if (response.status == 200) {
                    if (response.data.retCode === 1000) {
                        console.log(response.data)
                        self.adminName = response.data.results.adminName
                        self.adminMobile = response.data.results.adminMobile
                        let memberTotal = response.data.results.leagueMemberStatistic.memberTotal;
                        self.DSuperiorPhone = response.data.results.outParentLeagueAdminMobile
                        self.getLeagueMember(v)

                        // if (memberTotal <= 50) {
                        //     self.showPage = false
                        //     self.getLeagueMember(v)
                        // } else {
                        //     self.queryLeagueId = v
                        //     self.showPage = true
                        // }
                    }
                }
            });
            // reset select user
            this.userCard = '';
            this.ruleForm.selectUserId = ''
            this.ruleForm.selectUserName = ''
            this.userMobile = ''
            this.ruleForm.commonlyUsePhone = ''
        },

        getLeagueMember(v) {
            let param = new FormData()
            param.append('queryLeagueId', v)

            this.loading = true
            this.PF('/public/get501', param, {baseURL: cons.u}).then((response) => {
                this.loading = false
                if (response.status == 200) {
                    if (response.data.retCode === 1000) {
                        this.outLeagueUserOptions = response.data.results.userList
                        this.userList = response.data.results.userList
                        this.conflictUsers = response.data.results.conflictUsers

                        for (let i = 0; i < this.userList.length; i++) {
                            if (this.conflictUsers[this.userList[i].userId] == 0) {
                                this.userList[i].disabled = true
                            }
                        }


                    } else {
                        Toast(response.data.retMsg);
                    }
                } else {
                    Toast('获取数据发生异常.' + response.status);
                }
            }).catch((error) => {
                this.loading = false
                console.log(error)

            });
        },

        onOrgSelected(orgInfo) {
            console.log(orgInfo)
            this.ruleForm.selectedOrg = orgInfo.leagueName
            this.ruleForm.selectedOrgId = orgInfo.leagueId
            this.ruleForm.selectedOrgFullName = orgInfo.leagueFullName
            this.ruleForm.selectedLeagueTypeId = orgInfo.leagueTypeId


            this.showOrgPick = false
            this.initInLeagueAdmin(this.ruleForm.selectedOrgId)
        },
        onConfirmIsThree(p) {
            this.ruleForm.isForeign = p.value
            this.showPickerIsThree = false
            if(p.value == 0) {
                this.otherOrgName = ''
                this.ruleForm.otherOrgCode = ''
                this.isSanSheng = ''
            }
            console.log(this.ruleForm)
        },
        onConfirmThree(p) {
            this.ruleForm.otherOrgCode = p.value
            this.otherOrgName = p.name
            this.showPickerThree = false
        },
        onConfirmOutReason(p) {
            this.graduateName = ''
            this.ruleForm.whereToGraduate = -1
            this.ruleForm.outReson = p.value
            this.outReason = p.name
            this.showPickerOutReason = false
            this.toWhere(p.value)

            console.log(this.showWhereToGraduate)
            console.log(this.whereToGraduates)
        },
        onConfirmGraWhere(p) {
            this.ruleForm.whereToGraduate = p.value
            this.graduateName = p.name
            this.showPickerGraWhere = false

            console.log(this.ruleForm.outReson)

        },
        onConfirmOutUser(val) {
            if(val == null) {
                this.showPickerSelectOutUser = false
                return
            }
            this.userCard = val.identityCardNo;
            this.ruleForm.selectUserId = val.userId
            this.ruleForm.selectUserName = val.name

            this.userMobile = val.mobile
            this.showPickerSelectOutUser = false
            this.ruleForm.outReson = ''
            this.checkPersonGraduate()
        },

        sliceWhereToGraduate(industryTypeId) {
            this.whereToGraduates = cons.whereToGraduates.slice(0, 12)
            switch (industryTypeId) {
                case "06CZ":
                    // this.whereToGraduates = cons.whereToGraduates.slice(0, 2)
                    for (let i = 0; i < this.whereToGraduates.length; i++) {
                        if (i == 0 || i == 1) {
                            this.whereToGraduates[i].disabled = false
                        } else {
                            this.whereToGraduates[i].disabled = true
                        }
                    }
                    break
                case "052WQZX":
                case "071JNYGZXX":
                case "072SENYGZXX":
                    // this.whereToGraduates = cons.whereToGraduates.slice(0, 4)
                    for (let i = 0; i < this.whereToGraduates.length; i++) {
                        if (i < 4) {
                            this.whereToGraduates[i].disabled = false
                        } else {
                            this.whereToGraduates[i].disabled = true
                        }
                    }
                    break
                case "05PTGZ":
                    for (let i = 0; i < this.whereToGraduates.length; i++) {
                        if (i == 2 || i == 3) {
                            this.whereToGraduates[i].disabled = false
                        } else {
                            this.whereToGraduates[i].disabled = true
                        }
                    }
                    break
                case "051ZDZYYX":
                    // this.whereToGraduates = cons.whereToGraduates.slice(4, 6)
                    for (let i = 0; i < this.whereToGraduates.length; i++) {
                        if (i == 4 || i == 5) {
                            this.whereToGraduates[i].disabled = false
                        } else {
                            this.whereToGraduates[i].disabled = true
                        }
                    }
                    break
                case "03PTGDYX":
                    // this.whereToGraduates = cons.whereToGraduates.slice(6, 8)
                    // this.whereToGraduates = this.whereToGraduates.concat(cons.whereToGraduates.slice(11, 12))
                    for (let i = 0; i < this.whereToGraduates.length; i++) {
                        if (i == 6 || i == 7 || i == 11) {
                            this.whereToGraduates[i].disabled = false
                        } else {
                            this.whereToGraduates[i].disabled = true
                        }
                    }
                    break
                case "04ZYJYXX":
                    // this.whereToGraduates = cons.whereToGraduates.slice(8, 11)
                    for (let i = 0; i < this.whereToGraduates.length; i++) {
                        if (i == 8 || i == 9 || i == 10) {
                            this.whereToGraduates[i].disabled = false
                        } else {
                            this.whereToGraduates[i].disabled = true
                        }
                    }
                    break
            }
        },
        toWhere(outReason) {
            if (outReason == 10 && this.isSanSheng == "BJNG") {
                this.mustRemark = true
            } else {
                this.mustRemark = false
            }
            this.whereToGraduates = []
            switch (outReason) {
                case 11:
                    // this.whereToGraduates = cons.whereToGraduates.slice(0, 12)
                    this.showWhereToGraduate = true
                    this.ruleForm.whereToGraduate = ''
                    this.sliceWhereToGraduate(this.selectIndustryTypeId)
                    return true
                case 8:
                    this.whereToGraduates = cons.whereToGraduates.slice(12)
                    this.showWhereToGraduate = true
                    this.ruleForm.whereToGraduate = ''
                    return true
                default:
                    this.ruleForm.whereToGraduate = ''
                    this.showWhereToGraduate = false
                    return false
            }
        },

        toWhereIsOk(){
            switch (this.ruleForm.outReson) {
                case 8:
                case 11:
                    return true
                default:
                    return false
            }
        },



        onSubmit() {
            console.log(this.ruleForm)
            if (this.ruleForm.commonlyUsePhone.length == 0 || (this.ruleForm.commonlyUsePhone.length != 11 && this.ruleForm.commonlyUsePhone.length != 12)){
                this.$toast("请正常输入常用联系人联系方式")
                return
            }
            if(this.ruleForm.isForeign !== 1 && this.ruleForm.isForeign !== 0 ) {
                this.$toast("请选择是否是转出到三省")
                return
            }
            if (this.ruleForm.outReson === '') {
                this.$toast("请选择办理接转的原因")
                return
            }
            if(this.toWhereIsOk()) {
                if (this.ruleForm.whereToGraduate.length == 0){
                    this.$toast("请选择毕业去向")
                    return
                }
            }
            if (this.twoUnit) {
                if (this.ruleForm.unitName.length == 0) {
                    this.$toast("请输入"+this.unitNameTitle)
                    return
                } else if (this.MustAddress && this.ruleForm.unitAddress.length == 0) {
                    this.$toast("请输入"+this.unitAddressTitle)
                    return
                }
            }
            if (this.oneUnit) {
                if (this.ruleForm.unitAddress.length == 0) {
                    this.$toast("请输入"+this.unitAddressTitle)
                    return
                }
            }
            if (this.ruleForm.outReson != 6 && this.ruleForm.selectedOrgId.length == 0 && this.ruleForm.isForeign != 1) {
                this.$toast("请选择转入组织")
                return
            } else if (this.leagueId == this.ruleForm.selectedOrgId) {
                this.$toast("转出团支部和转入组织不能相同")
                return
            }
            if (this.ruleForm.isForeign == 1 && this.ruleForm.otherOrgCode.length == 0) {
                this.$toast("请选择转入省/市")
                return
            }
            if (this.ruleForm.isForeign==1
                &&this.ruleForm.outReson != 6){
                if (this.ruleForm.selectedOrgFullName.length==0){
                    this.$toast("请填写转入组织")
                    return
                }else if (this.ruleForm.selectedOrgFullName.length<=4){
                    this.$toast("转入组织全称长度必须大于4")
                    return
                } else if (this.ruleForm.selectedOrgFullName=='流动团员团支部'){
                    this.$toast("转入组织全称不能是'流动团员团支部'")
                    return
                }else if (this.ruleForm.selectedOrgFullName=='工作单位团组织'){
                    this.$toast("转入组织全称不能是'工作单位团组织'")
                    return
                }
            }
            if (this.ruleForm.outReson == 10 && this.isSanSheng == 'BJNG' && this.ruleForm.remark.length <= 0) {
                this.$toast("转接原因是'未就业'时,请填写备注")
                return
            }
            console.log(this.twoUnit, this.MustAddress, this.ruleForm.unitAddress)
            if (this.twoUnit && !this.MustAddress && this.ruleForm.unitAddress.length == 0) {
                this.$dialog.confirm({
                    title: '提示',
                    message: "如果不填写工作/学习单位详细地址，可能会导致转入团组织无法进行判断而拒绝接收组织关系。",
                })
                    .then(() => {
                        console.log("confirmed")
                        this.doSubmit()
                        // on confirm
                    }).catch(() => {
                    console.log("nothing")
                })
            } else {
                this.doSubmit()
            }
        },
        doSubmit() {
            let self = this
            let param = new FormData()
            param.append('currLeagueId', this.leagueId)
            param.append('currUserId', this.userId)
            for (let k in this.ruleForm) {
                param.append(k, this.ruleForm[k])
            }
            param.append("outParentLeagueAdminMobile",this.DSuperiorPhone)
            param.append("inAdminName",this.inAdminName)
            param.append("inAdminMobile",this.inAdminMobile)
            param.append('isApi', 1 )

            this.loading = true;
            this.PF('/business/transfer/transferoutinit', param, {baseURL: cons.u})
                .then((response) => {
                    this.loading = false
                    if (response.status == 200) {
                        if (response.data.retCode === 1000) {
                            //alert('ok,submit success!')
                            if (this.ruleForm.isForeign == 1 || this.isSanSheng === 'GDNG' || this.isSanSheng === 'BJNG' || this.isSanSheng === 'FJAN'){
                                let info = response.data.retMsg
                                let msg = info.replace(/\|/g,'<br>').replace(/\[/g,'<strong>').replace(/\]/g,'</strong>')
                                let ii = 5;

                                this.$dialog.confirm({
                                    title: '提示',
                                    message: msg,
                                    confirmButtonText:'请仔细阅读提示',

                                })
                                    .then(() => {
                                        console.log("confirmed")
                                        // on confirm
                                    })

                            }else{
                                self.$dialog.alert({
                                    message: response.data.retMsg,
                                    theme: 'round-button',
                                }).then(() => {
                                    self.jump("/transferProcess")
                                });
                                // this.$notify({
                                //     type: 'success',
                                //     message: response.data.retMsg,
                                //     onClose: () => {
                                //
                                //         this.jump("/transferProcess")
                                //     }
                                // })
                            }
                        } else {
                            self.$dialog.alert({
                                message: response.data.retMsg,
                                theme: 'round-button',
                            }).then(() => {
                            });
                            // this.$notify({
                            //     type: 'danger',
                            //     message: response.data.retMsg
                            // })
                            console.log("reCode:" + response.data.retCode)
                        }
                    } else {
                        console.log("Got Return code:" + response.status)
                    }
                })
                .catch((error) => {
                    this.loading = false
                    console.log(error);
                });
        },

        checkPersonGraduate() {
            let self = this
            var params = new FormData()
            params.append('currUserId', this.userId)
            params.append('currLeagueId', this.leagueId)
            params.append('queryLeagueId', this.ruleForm.outLeagueId)
            params.append('userId', this.ruleForm.selectUserId)
            this.PF('/checkPersonGraduate', params, {baseURL: cons.m}).then((response) => {
                this.loading = false
                if (response.status == 200) {
                    if (response.data.retCode === 1000) {
                        if (response.data.results.isGrad == 1) {
                            this.currentTransferReason = this.transferReason.slice(5)
                        } else {
                            this.currentTransferReason = this.transferReason.slice(0, 5)
                        }

                    } else {
                        self.$dialog.alert({
                            message: response.data.retMsg,
                            theme: 'round-button',
                        }).then(() => {
                        });
                        // this.$notify({
                        //     type: 'danger',
                        //     message: response.data.retMsg
                        // })

                    }
                }
            }).catch((error) => {
                this.loading = false
                console.log(error.config);
            });
        },
        initInLeagueAdmin(leagueId) {
            if (this.ruleForm.isForeign == 1){
                return false
            }
            let self = this
            let param = new FormData()
            param.append('queryLeagueId', leagueId)
            this.PF('/public/getLeagueAdmin', param, {baseURL: cons.m}).then((response) => {
                this.loading = false
                if (response.status == 200) {
                    if (response.data.retCode === 1000) {
                        console.log(response.data)
                        this.inAdminName =  response.data.results.inAdminName
                        this.inAdminMobile = response.data.results.inAdminMobile
                    } else {
                        this.$toast(response.data.retMsg)
                    }
                } else {
                    self.$dialog.alert({
                        message: '获取数据发生异常.' + response.status,
                        theme: 'round-button',
                    }).then(() => {

                    });
                    // this.$notify({
                    //     type: 'danger',
                    //     message: '获取数据发生异常.' + response.status
                    // })
                }
            }).catch((error) => {
                console.log(error)
            });
        },
    },
    created() {
        // this.checkPersonGraduate()
        console.log(this.options)
    }
}
</script>

<style scoped>
*{
    box-sizing: border-box;
}
.wrap {
    background-color: #eeedf0;
    /*background-color: white;*/
    height: auto;
    width: 100%;
    overflow-y: scroll;

}
.hd{
    padding-top: 50px;

}
.zhuanchu,.zhuanru{
    margin:10px 0;
    background-color: white;
    display: flex;
    align-items: flex-start;
}
.tag{
    background-color: #e32322;
    color: white;
    border-radius: 5px;
    padding: 0 5px;
    font-size: 13px;
    margin: 10px;

}
.zhuanru .tag{
    background-color: #ffa800;
}
.cell_wrap{
    flex: 1;
}
.btn_wrap{
    width: 80%;
    height: 40px;
    margin: 20px auto;
}
.telInput{
    border: none;
    text-align: right;
    outline: none;
}

/deep/ .van-cell-group {
    margin-top: 20px;
}
/deep/ .van-button--normal {
    width: 100%;
    border-radius: 5px;
}
/deep/ .van-dropdown-menu__title {
    color: #969799;
}
/deep/ .van-step__line{
    background-color: #c5c5c5;
}
/deep/ .van-steps{
    background-color:transparent;
}
/deep/ .van-step--horizontal .van-step__circle-container{
    background-color: #eeedf0;
}
/deep/ .van-step--horizontal .van-step__icon,/deep/ .van-step--horizontal .van-step__title{
    font-size: 14px;
}
.fullScreen {
    height: 100%;
}
/deep/ .selectOrg_wrap .van-button--normal {
    height: 30px;
    width: 60px;
    border-radius: 5px;
}

/deep/ .selectOrg_wrap .van-list .van-cell {
    border-bottom: 1px solid #ebedf0;
    padding: 10px 5px;
    align-items: center;

}

/deep/ .selectOrg_wrap .van-list .van-cell__title {
    padding-left: 10px;
    line-height: 30px;
    text-align: left;
    padding-right: 10px;
}
</style>
